import 'react-app-polyfill/stable';
import 'react-tooltip/dist/react-tooltip.css';
import 'utils/append.polyfill'; // it's not covered by core-js
import 'integration/iframeResizer';
import React from 'react';
import { Buffer } from 'buffer';
import { authenticateUser } from 'utils/keycloak';
import { getDomainName, Proxy } from 'utils';
import 'video-capture';
import { fetchAuthenticationApi } from 'common/api';
import { CtPrivacyRepository } from 'common/api/models/ct-privacy.repository';
import { Error403Page, Error500Page } from 'pages/error.pages';

import { store } from 'store';
import { initApp, root } from 'app.loader';
import { get } from 'lodash-es';

/*
 * Buffer is used by us and our dependencies, but its polyfilling has been removed in Webpack 5.
 * We are using the third-party library "buffer" to bring the polyfill back by the following line.
 */
window.Buffer = window.Buffer || Buffer;

Proxy.dispatch = store.dispatch;

const main = async () => {
  const authConfig = await fetchAuthenticationApi(getDomainName());

  // when /api/authentication return it means public website - just render app
  if (get(authConfig, 'status') === 204) {
    CtPrivacyRepository.setIsPublic(true);
  } else {
    await authenticateUser(authConfig);
    CtPrivacyRepository.setIsPublic(false);
  }

  await initApp();
};

(async () => {
  try {
    await main();
  } catch (error) {
    if (error?.status === 403) {
      root.render(<Error403Page error={error} />);
    }
    if (error?.status >= 500) {
      root.render(<Error500Page error={error} />);
    }
  }
})();
